//Common
import { fn_formatarCodigo, fn_getLabelSelContaBancaria } from "@/common/siig";

//Util
import { showMensagemErroApi } from "@/frontend/utils/mensagens";

//API
import api from "./api";
import {
  fn_dataFormatToFormatBanco,
  fn_getDescAbrevDiaSemanaData,
} from "@/common/utils/date";
import { fn_url_codificarValor } from "@/common/utils/util";

export const ROTA_LOAD = {
  //JOB_TIPO: "/job_tipo/listar",

  TENANT: "/tenant/listar",

  PERFIL: "/perfil/listar",
  USUARIO: "/usuario/listar",

  PESSOA_CONTA_BANCARIA: "/pessoa_conta_bancaria/listar",

  EMPRESA: "/empresa/listar",
  FILIAL: "/filial/listar",
  FORNECEDOR: "/fornecedor/listar",

  SETOR: "/setor/listar",
  BANDEIRA: "/bandeira/listar",

  CENTRO_CUSTO: "centro_custo/listar",

  UF: "/uf/listar",
  CIDADE: "/cidade/listar",

  AREA: "/area/listar",

  CONTA: "/conta/listar",
  CONTA_GRUPO: "/conta_grupo/listar",
  CONTA_NATUREZA: "/conta_natureza/listar",
  PLANO_CONTA: "/plano_conta/listar",

  FLUXO_GRUPO: "/fluxo_grupo/listar",

  BANCO: "banco/listar",
  FORMA_PAGAMENTO: "/forma_pagamento/listar",
  TIPO_DOCUMENTO: "/tipo_documento/listar",
  INDICE_REAJUSTE: "/indice_reajuste/listar",
  IMPOSTO: "/imposto/listar",

  PRODUTO_GRUPO: "/produto_grupo/listar",

  SOLICITACAO_TIPO: "/solicitacao_tipo/listar",

  //Rotas específicas
  UF_ENDERECO_FILIAIS: "uf/listarUFEnderecoFiliais",
  CIDADE_ENDERECO_FILIAIS: "cidade/listarCidadeEnderecoFiliais",

  AREA_USUARIOS_RESP: "/area/listarUsuariosResp",
  CONTA_TENANT_USUARIOS_RESP: "/conta_tenant/listarUsuariosResp",
};

/*
 * Carrega as opções conforme rota e filtros para popular componente que precisa de value e label (Ex: select)
 */
export async function api_loadOpcoes(
  rotaLoad,
  filtros,
  {
    addAll = true,
    opcaoAddPrimeiro = null,
    //addOpcaoTodos = false,
    addCodigoLabel = false,
    formatacaoCodigo = 3,
    labelSigla = false,
    campoValue = "id",
  } = {},
) {
  let opcoes = [];

  try {
    const { data } = await api.get(`${rotaLoad}?${filtros ? filtros : ""}`);

    let result = [];
    if (data?.items) {
      //se for um retorno com dados de paginação, obter apenas os itens
      result = data.items;
    } else {
      result = data;
    }

    opcoes = result.map((item) => {
      const { id, ...rest } = item; // remove o campo id para evitar problema caso o objeto vá para inclusão no banco onde o id é gerado

      const codigo =
        item.sigla ||
        fn_formatarCodigo(
          item.codigo || item.numero || item.matricula,
          formatacaoCodigo,
        );

      return {
        ...(campoValue != "id" ? { id: item.id } : {}),
        value: item[campoValue], //item.id,
        label:
          addCodigoLabel === true && codigo
            ? codigo + " - " + item.nome
            : labelSigla === true
              ? item.sigla || item.nome
              : item.nome,
        ...(addAll === true ? { ...rest } : {}),
      };
    });

    if (opcaoAddPrimeiro) {
      opcoes.unshift(opcaoAddPrimeiro);
    }

    // if (addOpcaoTodos == true) {
    //   fn_addPrimeiraOpcaoValorZero(opcoes, "TODOS");
    // }
  } catch (error) {
    showMensagemErroApi(error, "carregar os dados");
  }
  return opcoes;
}

export async function api_loadOpcoesTenant(filtros) {
  let opcoes = [];
  try {
    const { data } = await api.get(`/tenant/listar?${filtros ? filtros : ""}`);

    let result = [];
    if (data?.items) {
      //se for um retorno com dados de paginação, obter apenas os itens
      result = data.items;
    } else {
      result = data;
    }

    opcoes = result.map((item) => {
      return {
        value: item.id,
        label: item.nome,
      };
    });
  } catch (error) {
    showMensagemErroApi(error, "carregar os dados");
  }
  return opcoes;
}

/*
 * Carrega as opções de conta bancária conforme o filtro informado
 */
export async function api_loadOpcoesContaBancaria(filtros) {
  let opcoes = [];
  try {
    const { data } = await api.get(
      `${ROTA_LOAD.PESSOA_CONTA_BANCARIA}?${filtros ? filtros : ""}`,
    );

    let result = [];
    if (data?.items) {
      //se for um retorno com dados de paginação, obter apenas os itens
      result = data.items;
    } else {
      result = data;
    }

    opcoes = result.map((item) => {
      const { id, ...rest } = item; // remove o campo id para evitar problema caso o objeto vá para inclusão no banco onde o id é gerado

      return {
        value: item.id,
        label: fn_getLabelSelContaBancaria(item),
        ...rest,
      };
    });
  } catch (error) {
    showMensagemErroApi(error, "carregar as contas bancárias");
  }
  return opcoes;
}

/*
 * Carrega as opções de Feriado da filial em determinado ano
 */
export async function api_loadOpcoesFeriadoFilialAno(idFilial, ano) {
  let opcoes = [];
  try {
    const dataInicio = fn_url_codificarValor(`01/01/${ano}`);
    const dataFim = fn_url_codificarValor(`31/12/${ano}`);

    let filtros = `data_inicio=${dataInicio}&data_fim=${dataFim}`;

    if (idFilial) {
      filtros += `&id_filial=${idFilial}`;
    }

    const { data } = await api.get(`/feriado/listarFeriadoPeriodo?${filtros}`);

    opcoes = data.map((item) => ({
      value: item.id,
      label: item.data
        ? item.data +
          " (" +
          fn_getDescAbrevDiaSemanaData(item.data) +
          ") " +
          " - " +
          item.nome
        : item.nome,
      data: item.data,
    }));

    opcoes = opcoes.sort((a, b) =>
      fn_dataFormatToFormatBanco(a.data).localeCompare(
        fn_dataFormatToFormatBanco(b.data),
      ),
    );
  } catch (error) {
    showMensagemErroApi(error, "carregar feriados");
  }
  return opcoes;
}
